import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__credits">
        <span>Ot Solano - 2026</span>
        <img src="/Logo-1080x1080.png" alt="Ot Solano logo" />
        <span>Web development by Maria Cidoncha</span>
      </div>
    </footer>
  );
}
